/* eslint-disable */
import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue } from "@chakra-ui/react";

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes } = props;


  // useEffect(()=>{
  //   routes?.map(route=>{
  //    if(route?.path==`/${location?.pathname?.split('/')[2]}`){
  //     console.log("here")
  //    }
  //   })

  // },[location])

  // useEffect(()=>{
  //   routes?.map(route=>{
  //     if(route?.name=='Users Listing'){
  //       activeRoute('/dashboard')
  //     }
  //   })
  // },[location])

  useEffect(()=>{

    const dynamicPath = '/admin/coin-detail/';
    if (location?.pathname.startsWith(dynamicPath)) {
      let location={}
      console.log("here i am");
      location['pathname']='/admin/dashboard'
      activeRoute('/dashboard');
      console.log(location,"location")
    }
  },[location])

  // console.log(location?.pathname)

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    console.log('routeName',routeName)

    console.log('location.pathname.includes(routeName)',location.pathname.includes(routeName))
    // routeName==="/user" ? routeName="/users-listing ":routeName
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.category) {
        return (
          <React.Fragment key={index}>
            <Text
              fontSize={"md"}
              color={activeColor}
              fontWeight='bold'
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt='18px'
              pb='12px'
              key={index}>
              {route.name}
            </Text>
            {createLinks(route.items)}
          </React.Fragment>
        );
      } else if (
        route.layout === "/admin"
      ) {
        return (
          <React.Fragment key={index}>
          {
            route?.name && <NavLink key={index} to={route.layout + route.path}>
            {(route.icon && route.name)? (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py='5px'
                  ps='10px'>
                  <Flex w='100%' alignItems='center' justifyContent='center'>
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : textColor
                      }
                      me='18px'>
                      {route.icon}
                    </Box>
                    
<Text
                      me='auto'
                      color={
                        activeRoute( route.path.toLowerCase())
                          ? activeColor
                          : textColor
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase())
                          ? "bold"
                          : "normal"
                      }>
                      {route.name}
                    </Text>
                      
                    
                  </Flex>
                  <Box
                    h='36px'
                    w='4px'
                    bg={
                      activeRoute(route.path.toLowerCase())
                        ? brandColor
                        : "transparent"
                    }
                    borderRadius='5px'
                  />
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                  py='5px'
                  ps='10px'>
                    {route.name && (<Text
                    me='auto'
                    color={
                      activeRoute(  route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }>
                    {route.name}
                  </Text>)}
                  
                  {/* <Box h='36px' w='4px' bg='brand.400' borderRadius='5px' /> */}
                </HStack>
              </Box>
            )}
          </NavLink>
          }
         
          </React.Fragment>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
